import styled from 'styled-components';

export const ImageOverlay = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${props => props.overlayColor};
    opacity: ${props => props.overlayOpacity};
`